import { render, staticRenderFns } from "./Website.vue?vue&type=template&id=77d068ab"
import script from "./Website.vue?vue&type=script&lang=js"
export * from "./Website.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_css-loader@3.6.0_webpack@4.47.0__ejs@3.1.10_66cafdebd9b3647e04b2d113c5f27dd4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports